export default __webpack_public_path__ + "static/media/about-flowers.00fb8eb3.jpg";